import { useTranslation } from 'react-i18next';
import UtilityDrawerBody from '../utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from '../utility-drawer/utility-drawer.component';
import FranchiseLoyaltyApiDefinitions from './franchise-loyalty-api-definitions/franchise-loyalty-api-definitions.component';

type FranchiseLoyaltyAPIDetailsDrawerProps = {
  isOpen: boolean;
  close: () => void;
};

const FranchiseLoyaltyAPIDetailsDrawer = ({
  isOpen,
  close,
}: FranchiseLoyaltyAPIDetailsDrawerProps) => {
  const { t } = useTranslation();
  return (
    <UtilityDrawer
      open={isOpen}
      onClose={close}
      title={t(
        'page.loyaltyPerformanceReport.tabs.franchiseLoyaltyOverview.label',
      )}
    >
      <UtilityDrawerBody>
        <FranchiseLoyaltyApiDefinitions />
      </UtilityDrawerBody>
    </UtilityDrawer>
  );
};

export default FranchiseLoyaltyAPIDetailsDrawer;
